export const getRevisionLabel = (revision) => `${String(revision?.phase || '').toUpperCase()} ${revision?.revision_index || ''}`.trim();
export const getCalculation = (revision) => revision?.engine_response_json || null;
export const buildNodeMap = (revision) => new Map((revision?.nodes || []).map((node) => [node.node_key || String(node.id), node]));
export const getRootNodes = (revision) => {
  const nodes = revision?.nodes || [];
  const ids = new Set(nodes.map((node) => node.id));
  return nodes.filter((node) => node.parent_id == null || !ids.has(node.parent_id)).sort((a, b) => a.position - b.position);
};
export const buildChildrenMap = (revision) => {
  const map = new Map();
  (revision?.nodes || []).forEach((node) => { const key = node.parent_id == null ? null : node.parent_id; map.set(key, [...(map.get(key) || []), node]); });
  map.forEach((nodes) => nodes.sort((a, b) => a.position - b.position));
  return map;
};
